import React from "react";
import { Tooltip } from "@vibe/core";
import { Check, Warning, Placeholder } from "@vibe/icons";
import { IoSync } from "react-icons/io5";

interface ItemViewDiscrepancyIconProps {
  itemViewDiscrepancy: any;
  isItemViewDiscrepancyLoading: boolean;
  column: any;
  itemViewDiscrepancyError: boolean;
  isResyncing?: boolean;
}

const ItemViewDiscrepancyIcon = ({
  itemViewDiscrepancy,
  isItemViewDiscrepancyLoading,
  column,
  itemViewDiscrepancyError,
  isResyncing = false,
}: ItemViewDiscrepancyIconProps) => {
  if (itemViewDiscrepancyError) {
    return null;
  }

  if (isResyncing) {
    return (
      <div>
        <Tooltip content={`Resyncing ${column.title} in the background…`}>
          <div className="flex justify-center items-center w-4 h-4 bg-[#0073EA] rounded-full">
            <IoSync size={10} color="#ffffff" className="animate-spin" />
          </div>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      {isItemViewDiscrepancyLoading ? (
        <Placeholder
          size={16}
          className={`${isItemViewDiscrepancyLoading ? "animate-spin" : ""}`}
        />
      ) : itemViewDiscrepancy && itemViewDiscrepancy?.hasDiscrepancy ? (
        <Tooltip content={`There are discrepancies in this item's ${column.title} column`}>
          <div className="flex justify-center items-center w-4 h-4 bg-yellow-500 rounded-full">
            <Warning size={12} color="#ffffff" />
          </div>
        </Tooltip>
      ) : (
        <Tooltip content={`All values are synchronized for ${column.title} column`}>
          <div className="flex justify-center items-center w-4 h-4 bg-green-500 rounded-full">
            <Check size={12} color="#ffffff" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default ItemViewDiscrepancyIcon;
